<!-- src/app/orders/admin-order-status/admin-order-status.component.html -->
<div class="p-6 max-w-6xl mx-auto">
  <h2 class="text-2xl font-semibold mb-4">Orders Management</h2>

  <div *ngIf="loading" class="text-gray-500">Loading orders...</div>

  <table *ngIf="!loading" class="min-w-full bg-white">
    <thead>
      <tr class="bg-gray-100 text-left">
        <th class="p-3">Order ID</th>
        <th class="p-3">Customer</th>
        <th class="p-3">Total</th>
        <th class="p-3">Order Status</th>
        <th class="p-3">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let order of orders" class="border-t">
        <td class="p-3">{{ order.id }}</td>
        <td class="p-3">{{ order.customerEmail || order.customerName }}</td>
        <td class="p-3">{{ order.totalAmount | currency }}</td>
        <td class="p-3">
          <select [(ngModel)]="order.currentStatus" class="p-1 border rounded">
            <option *ngFor="let s of statuses" [value]="s">{{ s }}</option>
          </select>
        </td>
        <td class="p-3">
          <textarea [(ngModel)]="description" class="w-full p-2 border rounded mb-3"
                    placeholder="Optional description..."></textarea>
        </td>
        <td class="p-3 space-x-2">
          <button (click)="updateStatus(order, order.currentStatus,description)" class="px-3 py-1 bg-green-600 text-white rounded">Update</button>
          <button (click)="openTracking(order.orderId)" class="px-3 py-1 bg-blue-600 text-white rounded">View Timeline</button>
        </td>
      </tr>
    </tbody>
  </table>

  <div *ngIf="selectedOrder" class="mt-6 p-4 bg-gray-50 rounded">
    <h3 class="font-bold mb-2">Order #{{ selectedOrder.orderId }} Timeline</h3>
    <div *ngFor="let e of selectedOrder.events">
      <div class="text-sm text-gray-500">{{ e.timestamp | date:'medium' }}</div>
      <div class="font-medium">{{ e.title }}</div>
      <div class="text-sm text-gray-600 mb-3">{{ e.description }}</div>
    </div>
  </div>
</div>
